export const ApiService = {
  "/fieldglass": "Fieldglass",
  "/Fieldglass": "Fieldglass",
  "/frontend/activityItem/": "Fieldglass",
  "/activityItem/reset-validation": "Fieldglass",
  "/ExternalData": "Fieldglass",
  "/ExternalData/updateMassive/file": "Fieldglass",
  "/ExternalData/updateByWorkerId": "Fieldglass",
  "/manual-validation/superManualValidation": "Fieldglass",
  "/manual-validation/manualValidation": "Fieldglass",
  "/worker/create": "Fieldglass",
};
